import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "justify-center row message-chip" }

import { ref, computed } from 'vue';

interface Props {
  display: boolean | false;
  level: string;
  message: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MessageChip',
  props: {
    display: { type: Boolean },
    level: {},
    message: {}
  },
  setup(__props: any) {

const props = __props;

const infoDisp = ref(computed(() => props.display));
const infoMessage = ref(computed(() => props.message));
const infoLevel = ref(computed(() => props.level));

const ERROR_LEVEL = {
  INFORMATION: 'I',
  WARNING: 'W',
  ERROR: 'E',
};

return (_ctx: any,_cache: any) => {
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_chip, {
      modelValue: infoDisp.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((infoDisp).value = $event)),
      square: "",
      class: _normalizeClass(
        infoLevel.value === ERROR_LEVEL.ERROR
          ? 'bg-negative'
          : infoLevel.value === ERROR_LEVEL.WARNING
          ? 'bg-warning'
          : 'bg-info'
      ),
      "text-color": "white",
      icon: "mdi-alert-circle",
      size: "15px"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(infoMessage.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "class"])
  ]))
}
}

})